import ObservationView from '../components/observation/view/index.vue'
import ObservationEdit from '../components/observation/edit/ObservationEdit.vue'
import ObservationList from '../components/observation/List'

export default [
  {
    name: 'ObservationShow',
    path: '/observation/show/:id',
    component: ObservationView,
    props: true,
    meta: {requiresAuth: false}
  },
  {
    name: 'ObservationEdit',
    path: '/observation/edit/:id',
    component: ObservationEdit,
    meta: {hideFooter: true, requiresAuth: true}
  },
  {name: 'ObservationList', path: '/observations/', component: ObservationList, meta: {requiresAuth: false}}
]
